export enum PlanTypeEnum {
	ODONTO = 'ODONTO',
	HEALTH = 'SAUDE',
	HEALTH_ODONTO = 'SAUDE+ODONTO',
}
